import React from "react";
import cookie from "react-cookies";
import queryString from "query-string";


import * as ROUTES from "../../constant/routes";

import { AppInstall } from "../common/svg";

import images_appstore from "../../static/images/landingpage/install/appstore.png";
import images_googleplay from "../../static/images/landingpage/install/playstore.png";
import interact from "../../static/images/landingpage/explorer/dich_vu_cho_thue_oto_tu_lai.png";

class AppAds extends React.Component {

	onIOSAppClick = () => {
		//GA
		const utmSrc = cookie.load("_utm_src") || "web_directly";
		const utmExt = cookie.load("_utm_ext") || "no_label";
		window.gtag("event", "INSTALL_APP_IOS", {
			event_category: utmSrc,
			event_label: utmExt,
			campaign: { source: utmSrc },
		});
		// window.ga("send", "event", utmSrc, "INSTALL_APP_IOS", utmExt);
		window.fbq("track", "INSTALL_APP_IOS");
	};

	onAndrAppClick = () => {
		//GA
		const utmSrc = cookie.load("_utm_src") || "web_directly";
		const utmExt = cookie.load("_utm_ext") || "no_label";
		window.gtag("event", "INSTALL_APP_ANDR", {
			event_category: utmSrc,
			event_label: utmExt,
			campaign: { source: utmSrc },
		});
		// window.ga("send", "event", utmSrc, "INSTALL_APP_ANDR", utmExt);
		window.fbq("track", "INSTALL_APP_ANDR");
	};

	render() {
		let linkIOS = `${ROUTES.installIOS}` ;
		let linkAndroid = `${ROUTES.installAndroid}`;
		let utmSrc = cookie.load("_utm_src") || "Web2App";

		if (utmSrc !== "") {
			linkIOS = `${linkIOS}&campaign=${utmSrc}&utm_source=${utmSrc}`;
			linkAndroid = `${linkAndroid}&campaign=${utmSrc}&utm_source=${utmSrc}`;
		}

		return (
			<div className="explorer-section third">
				<div className="m-container">
					<div className="explorer-container">
						<div className="explorer-item">
							<div className="explorer-item__content">
								<div className="wrap-svg">
									<AppInstall />
								</div>
								<h2>
									Trải nghiệm trọn&nbsp;vẹn <br />
									cùng ứng dụng Mioto
								</h2>
								<div className="install-img">
									<a href={linkIOS} onClick={this.onIOSAppClick}>
										<img loading="lazy" src={images_appstore} />
									</a>
									<a href={linkAndroid} onClick={this.onAndrAppClick}>
										<img loading="lazy" src={images_googleplay} />
									</a>
								</div>
							</div>
							<div className="explorer-item__img">
								<img loading="lazy" src={interact} alt="dich_vu_cho_thue_oto_tu_lai" />
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default AppAds;
